// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"90ba9ffb","234":"90ba9ffb","285":"90ba9ffb","352":"90ba9ffb","447":"90ba9ffb","545":"90ba9ffb","712":"6b24735d"}[chunkId] + ".chunk.css";
};